module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 170.72814275.png";